import { SideMenu } from './side-menu';
import { BLOG_NAVBAR_CONTAINER, BLOG_SHOP_KETONE_BUTTON } from '../classnames/blog';
import { ACTIVE_SIDE_BAR, SIDE_MENU_OVERLAY } from '../classnames/sidebar-popup';
import { CART_EVENTS } from '../custom-events/cart';

const Scroll = {
  up: 'up',
  down: 'down'
};

const SCROLL_AMOUNT_TO_HIDE_NAVBAR = 200;

const HIDDEN_NAVBAR_CLASS = 'navigation--blog--hidden';
const SHOW_NAVBAR_CLASS = 'navigation--blog--visible';

const SHOW_SHOP_KETONE_BUTTON_CLASS = 'blog-shop-ketone-button--visible';
const HIDDEN_SHOP_KETONE_BUTTON_CLASS = 'blog-shop-ketone-button--hidden';

const BURGER_ACTIVE_CLASS = 'burger-icon--active';
const BURGER_LABELS = { open: 'Close menu', closed: 'Open menu' };

export default class MobileNavigation {
  sideMenu = new SideMenu();
  menuContainerId = 'mobile-side-menu-container';
  supportContainerId = 'mobile-side-menu-support';
  menuItemExpandedClass = 'navigation__mobile-side-menu-item--expanded';
  menuWithSubItems = document.getElementsByClassName('js-menu-item-with-sub-items');
  burger = document.getElementById('navigation-burger');
  bar = document.getElementById('mobile-navigation-bar');
  support = document.getElementById('mobile-navigation-support');
  supportClose = document.getElementById('mobile-support-close');

  setBurgerActive = (active) => {
    const icon = this.burger?.querySelector('.burger-icon');

    this.burger?.setAttribute('aria-expanded', active);
    this.burger?.setAttribute('aria-label', active ? BURGER_LABELS.open : BURGER_LABELS.closed);

    if (!icon) return;

    icon.classList.toggle(BURGER_ACTIVE_CLASS, active);
  };

  previousScrollPosition = 0;

  blogNavbarContainers = document.querySelectorAll(`.${BLOG_NAVBAR_CONTAINER}`);
  blogShopKetoneButton = document.querySelector(`.${BLOG_SHOP_KETONE_BUTTON}`);

  isBlogNavbarHidden = false;
  isBlogShopKetoneButtonHidden = false;

  showMenu = () => {
    this.sideMenu.hideAll();
    this.sideMenu.show(this.menuContainerId);
    this.setBurgerActive(true);

    if (this.bar) {
      this.bar.classList.add('navigation--bordered');
    }
  };

  openSupport = () => {
    this.sideMenu.show(this.supportContainerId);
  };

  closeSupport = () => {
    this.sideMenu.hide(this.supportContainerId);
  };

  closeAll = () => {
    this.sideMenu.hideAll();
    this.resetMenuState();
  };

  closeMenu = () => {
    this.sideMenu.hide(this.menuContainerId);
    this.resetMenuState();
  };

  resetMenuState = () => {
    this.setBurgerActive(false);

    if (this.bar) {
      this.bar.classList.remove('navigation--bordered');
    }
  };

  toggleMenu = () => {
    if (document.querySelector(`.${ACTIVE_SIDE_BAR}`)) {
      this.closeAll();
    } else {
      this.showMenu();
    }
  };

  toggleMenuItem = ({ target }) => {
    const parentLink = target.closest('a');

    if (!parentLink) {
      const menuItem = target.closest('.js-menu-item-with-sub-items');
      const productLinksContainer = menuItem.parentElement;
      const topLevelContainer = productLinksContainer.parentElement;

      if (menuItem.classList.contains(this.menuItemExpandedClass)) {
        topLevelContainer.scroll({ top: 0, behavior: 'smooth' });
        productLinksContainer.style.height = null;
        menuItem.classList.remove(this.menuItemExpandedClass);
      } else {
        if (topLevelContainer.offsetHeight > menuItem.offsetHeight) {
          productLinksContainer.style.height =
            `${productLinksContainer.offsetHeight + (topLevelContainer.offsetHeight - menuItem.offsetHeight)}px`;
        }
        topLevelContainer.scroll({ top: menuItem.offsetTop - productLinksContainer.offsetTop, behavior: 'smooth' });
        menuItem.classList.add(this.menuItemExpandedClass);
      }
    }
  };

  handeScroll = () => {
    const currentScrollPosition = window.scrollY;
    const previousScrollPosition = this.previousScrollPosition || 0;
    const direction = currentScrollPosition > previousScrollPosition ? Scroll.down : Scroll.up;

    this.previousScrollPosition = currentScrollPosition;

    if (direction === Scroll.down && currentScrollPosition > SCROLL_AMOUNT_TO_HIDE_NAVBAR) {
      this.blogNavbarContainers.forEach((blogNavbarContainer) => {
        blogNavbarContainer.classList.remove(SHOW_NAVBAR_CLASS);
        blogNavbarContainer.classList.add(HIDDEN_NAVBAR_CLASS);
      });
      this.blogShopKetoneButton.classList.remove(SHOW_SHOP_KETONE_BUTTON_CLASS);
      this.blogShopKetoneButton.classList.add(HIDDEN_SHOP_KETONE_BUTTON_CLASS);
      this.isBlogNavbarHidden = true;
      this.isBlogShopKetoneButtonHidden = true;
    } else if (direction === Scroll.up && this.isBlogNavbarHidden && this.isBlogShopKetoneButtonHidden) {
      this.blogNavbarContainers.forEach((blogNavbarContainer) => {
        blogNavbarContainer.classList.remove(HIDDEN_NAVBAR_CLASS);
        blogNavbarContainer.classList.add(SHOW_NAVBAR_CLASS);
      });
      this.blogShopKetoneButton.classList.remove(HIDDEN_SHOP_KETONE_BUTTON_CLASS);
      this.blogShopKetoneButton.classList.add(SHOW_SHOP_KETONE_BUTTON_CLASS);
      this.isBlogNavbarHidden = false;
      this.isBlogShopKetoneButtonHidden = false;
    }
  };

  initializeEventListeners = () => {
    document.addEventListener(CART_EVENTS.OPEN, this.closeMenu);
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains(SIDE_MENU_OVERLAY)) {
        this.closeMenu();
      }
    });

    if (window.location.pathname.includes('/blogs')) {
      document.addEventListener('scroll', this.handeScroll);
    }

    if (this.burger) {
      this.burger.addEventListener('click', this.toggleMenu);
    }

    if (this.support) {
      this.support.addEventListener('click', this.openSupport);
    }

    if (this.supportClose) {
      this.supportClose.addEventListener('click', this.closeSupport);
    }
  };
}
